import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import {login} from '../auth/identityAuth';
import Button from '@material-ui/core/Button';

const Error = (props: any) => {
  return (
    <div>
      {props.match.params.code !== '401' && props.match.params.code !== '403' &&
        <Typography variant="display4" align="center" color='secondary'>
          oh no ...
        </Typography>
      }
      {(props.match.params.code === '401' || props.match.params.code === '403') &&
        <Typography variant="display3" align="center" color='secondary'>
          Unauthorized
        </Typography>
      }
      {props.match.params.code === '401' &&
        <div>
          <Typography variant="display1" align="center" gutterBottom={true}>
            Please log in,
          </Typography>
          <Typography variant="display1" align="center" gutterBottom={true}>
            then try your request again.
          </Typography>
          <Typography align="center" variant="caption">
            <Button onClick={login}>Log in</Button>
          </Typography>
        </div>
      }
      {props.match.params.code === '403' &&
        <div>
          <Typography variant="display1" align="center" gutterBottom={true}>
            Not allowed to access this page,
          </Typography>
          <Typography variant="display1" align="center" gutterBottom={true}>
            contact your company admin to get access to this page.
          </Typography>
        </div>
      }
      {props.match.params.code !== '401' && props.match.params.code !== '403' &&
        <div>
          <Typography variant="display3" align="center" color='secondary'>
            Error {props.match.params.code || 404}
          </Typography>
          <Typography align="center" variant="caption" gutterBottom={true}>
            {props.match.params.message || 'The page you requested does not exist.'}
          </Typography>
        </div>
      }
      <Typography align="center" variant="caption">
        {props.match.params.code === '404' &&
          <Button onClick={props.history.goBack}>Back</Button>
        }
      </Typography>
    </div>
  )
}

export default Error;


// WEBPACK FOOTER //
// ./src/modules/core/pages/Error.tsx